export function isSessionError(errorMessage: string): boolean {
  const lowerCaseMessage = errorMessage.toLowerCase();
  return (
    lowerCaseMessage.includes('sessionnotapprovederror') ||
    lowerCaseMessage.includes('session not found') ||
    lowerCaseMessage.includes('batch session not initialized') ||
    lowerCaseMessage.includes('sessiondestinationnotapprovederror') ||
    lowerCaseMessage.includes('sessionruleviolationerror') ||
    lowerCaseMessage.includes('invalidsmartaccountnonceerror') ||
    lowerCaseMessage.includes('aa25') ||
    lowerCaseMessage.includes('aa23')
  );
}
